import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

export interface LangDictionaryData {
  langDictionary: string
}

export const GET_LANG_DICTIONARY_QUERY = gql`
    query langDictionary($lang: String){
        langDictionary(lang: $lang)
    }
`;

export const langDictionary = (lang: string) => useQuery<LangDictionaryData>(
  GET_LANG_DICTIONARY_QUERY,
  {
    variables: {
      lang,
    }
  }
);

export default langDictionary;